import sdl from '@jds/react-generated-sdl/JDSPromoCard';
import type { JDSPromoCardProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, PromoCardProps } from '../logic';

const Component = (props: PromoCardProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'small',
    orientation = 'vertical',
    imageRatio = 'wide',
    imageFocus = 'undefined',
    shadow = true,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, orientation, imageRatio, imageFocus, shadow, ...rest },
    'JDSPromoCard',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const PromoCard = withLogic(Component) as React.FC<PromoCardProps> & {
  slotName?: string;
};

PromoCard.displayName = 'PromoCard';
PromoCard.slotName = 'jds_promo_card';

export { PromoCard, type JDSPromoCardProps };
